import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import appendQuery from 'append-query';
import isMobile from 'ismobilejs'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import { ElementInteraction, Impression } from '@nerdwallet/nw-client-lib/tracking';
import Button from '@nerdwallet/react-button';
import Link from '@nerdwallet/react-link';
import { Heading, Text } from '@nerdwallet/react-typography';
import programClick from '../../lib/tracking/program-click';
import style from './program-card.module.less';
var CHAR_LIMIT_DESKTOP = 300;
var CHAR_LIMIT_MOBILE = 120;

var ProgramCard = /*#__PURE__*/function (_Component) {
  _inherits(ProgramCard, _Component);

  var _super = _createSuper(ProgramCard);

  function ProgramCard(props) {
    var _this;

    _classCallCheck(this, ProgramCard);

    _this = _super.call(this, props);
    _this.state = {
      expanded: false
    };
    _this.toggleExpand = _this.toggleExpand.bind(_assertThisInitialized(_this));
    _this.fireClickEvent = _this.fireClickEvent.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProgramCard, [{
    key: "toggleExpand",
    value: function toggleExpand() {
      // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
      var expanded = !this.state.expanded;
      this.setState({
        expanded: expanded
      });
    }
  }, {
    key: "fireClickEvent",
    value: function fireClickEvent() {
      var _this$props = this.props,
          program = _this$props.program,
          impressions = _this$props.impressions;
      var id = program.id,
          productSlug = program.productSlug;

      var impressionId = _get(impressions, "fthb-program-card-".concat(id, ".impressionHeader.impressionId"));

      programClick({
        impressionId: impressionId,
        productId: id,
        productSlug: productSlug,
        productLocation: 'body',
        sponsored: false,
        monetizing: false
      });
    }
  }, {
    key: "renderReadMore",
    value: function renderReadMore() {
      var expanded = this.state.expanded;

      var id = _get(this.props, 'program.id');

      var text = expanded ? 'less' : 'more';
      return /*#__PURE__*/React.createElement(ElementInteraction, {
        id: "fthb-program-card-read-".concat(text, "-").concat(id),
        type: "CLICK",
        elementName: "fthb-program-card-read-".concat(text)
      }, /*#__PURE__*/React.createElement(Link, {
        className: style.detailsExpand,
        onClick: this.toggleExpand
      }, expanded ? 'Read Less' : 'Read More'));
    }
  }, {
    key: "renderBestFor",
    value: function renderBestFor() {
      var program = this.props.program;

      if (!program.bestFor) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
        bold: true,
        className: style.bestForTitle,
        uppercase: true
      }, "Best for"), /*#__PURE__*/React.createElement("div", {
        className: style.bestFor
      }, program.bestFor.map(function (pro) {
        return /*#__PURE__*/React.createElement(Text, {
          className: style.bestForItem,
          key: pro
        }, pro);
      })));
    }
  }, {
    key: "renderDetails",
    value: function renderDetails() {
      var expanded = this.state.expanded; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

      var description = this.props.program.description;
      var charLimit = expanded ? description.length : ProgramCard.getCharLimit(description);
      var shouldRenderEllipsis = description.length > charLimit && !expanded;
      return /*#__PURE__*/React.createElement("div", {
        className: style.details
      }, /*#__PURE__*/React.createElement(Text, {
        bold: true,
        uppercase: true,
        className: style.detailsTitle
      }, "What you need to know"), /*#__PURE__*/React.createElement(Text, {
        className: style.detailsBody
      }, shouldRenderEllipsis ? description.substring(0, charLimit).concat('... ') : description.substring(0, charLimit).concat(' '), description.length <= charLimit && !expanded ? null : this.renderReadMore()));
    }
  }, {
    key: "renderCard",
    value: function renderCard() {
      // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
      var _this$props$program = this.props.program,
          cta = _this$props$program.cta,
          ctaText = _this$props$program.ctaText,
          designation = _this$props$program.designation,
          disclaimer = _this$props$program.disclaimer,
          name = _this$props$program.name;
      return /*#__PURE__*/React.createElement("div", {
        className: style.card
      }, /*#__PURE__*/React.createElement("div", {
        className: style.header
      }, /*#__PURE__*/React.createElement("div", {
        className: style.headerTitle
      }, /*#__PURE__*/React.createElement(Heading, {
        className: style.headerHeading,
        level: 3
      }, name), /*#__PURE__*/React.createElement(Text, {
        className: style.designation,
        small: true
      }, designation)), /*#__PURE__*/React.createElement("div", {
        className: style.cta
      }, /*#__PURE__*/React.createElement(Button, {
        className: style.ctaButton,
        href: appendQuery(cta, 'trk_topic=FTHBstate&trk_location=card'),
        onClick: this.fireClickEvent,
        primary: true,
        target: "_blank"
      }, ctaText), /*#__PURE__*/React.createElement(Text, {
        className: style.ctaDisclaimer,
        small: true
      }, disclaimer))), /*#__PURE__*/React.createElement("div", {
        className: style.body
      }, this.renderBestFor(), this.renderDetails()));
    }
  }, {
    key: "render",
    value: function render() {
      var program = this.props.program;
      var name = program.name,
          cta = program.cta,
          ctaText = program.ctaText,
          description = program.description,
          id = program.id,
          productSlug = program.productSlug;

      if (!(name && cta && ctaText && description)) {
        return null;
      } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


      if (!this.props.impressions) {
        return this.renderCard();
      }

      return /*#__PURE__*/React.createElement(Impression, {
        id: "fthb-program-card-".concat(id),
        eventName: "GENERIC_IMPRESSION_EVENT",
        eventData: {
          impressionHeader: {
            productId: id,
            productSlug: productSlug,
            productLocation: 'body'
          }
        }
      }, this.renderCard());
    }
  }], [{
    key: "getCharLimit",
    value: function getCharLimit(description) {
      // TODO no isMobile
      var limit = isMobile.any ? CHAR_LIMIT_MOBILE : CHAR_LIMIT_DESKTOP;

      if (description.length < limit) {
        return description.length;
      }

      while (description[limit] !== ' ' && limit > 0) {
        limit -= 1;
      }

      return limit;
    }
  }]);

  return ProgramCard;
}(Component);

_defineProperty(ProgramCard, "displayName", 'ProgramCard');

_defineProperty(ProgramCard, "propTypes", {
  program: PropTypes.shape({
    bestFor: PropTypes.arrayOf(PropTypes.string).isRequired,
    name: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    disclaimer: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    productSlug: PropTypes.string.isRequired
  }).isRequired,
  impressions: PropTypes.object // eslint-disable-line react/forbid-prop-types

});

_defineProperty(ProgramCard, "defaultProps", {
  impressions: null
});

export { ProgramCard as default };